function pushIndex(array) {
  var changed = [];
  array.map((original, index) => changed.push({ ...original, id: index + 1 }));
  return changed;
}
const uploads = [
  {
    title: "Upload Outlet Status",
    api: "/upload-outlet-status",
    userTypes: ["bkash-super-user", "cluster_head", "area_manager"],
    // helpText: "Select from computer",
    file_tag: "Merchant Status",
    group: "Information",
  },
  {
    title: "People Hierarchy Uploader",
    api: "/upload-people-hierarchy",
    userTypes: ["bkash-super-user"],
    // helpText: "Select from computer",
    file_tag: "People Hierarchy Uploader",
    group: "Information",
    isEmailRequired: true,
  },
  {
    title: "Merchant Category Uploader",
    api: "/upload-merchant-category",
    userTypes: ["bkash-super-user"],
    file_tag: "Merchant Category Uploader",
    group: "Information",
    isEmailRequired: true,
  },
  {
    title: "Categorization File LMC Values Updater",
    api: "/upload-merchant-category-lmc",
    userTypes: ["bkash-super-user"],
    file_tag: "Merchant Category LMC Uploader",
    group: "Information",
    isEmailRequired: true,
  },
  {
    title: "EMS Tag, CCD, Serving Channel (MDT), and Registering Channel (MDT)",
    api: "/upload-ems-tag-and-ccd",
    userTypes: ["bkash-super-user"],
    file_tag: "EMS Tag, CCD, Serving Channel & Registering Channel Uploader",
    group: "Information",
    isEmailRequired: true,
  },
  {
    title: "Merchant Banking List Uploader",
    api: "/upload-merchant-banking-list",
    userTypes: ["bkash-super-user"],
    file_tag: "Merchant Banking List Uploader",
    group: "Mapping",
    isEmailRequired: true,
  },
  {
    title: "Merchant Quiz Configuration Uploader",
    api: "/upload-quiz-config",
    userTypes: ["bkash-super-user"],
    // helpText: "Select from computer",
    file_tag: "Merchant Quiz Configuration",
    group: "Campaign",
    isEmailRequired: true,
  },
  {
    title: "Merchant Location Uploader",
    api: "/upload-merchant-locations",
    userTypes: ["bkash-super-user", "cluster_head"],
    // helpText: "Select from computer",
    file_tag: "Merchant-Locations Update",
    group: "Information",
    isEmailRequired: true,
  },
  {
    title: "Reset Route Outlet Mapping",
    api: "/upload-reset-route-outlet-mapping",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Reset-Route-Outlet Mapping",
    group: "Mapping",
  },
  {
    title: "Upload Outlet Campaign",
    api: "/upload-outlet-campaign",
    userTypes: ["bkash-super-user", "area_manager", "cluster_head"],
    file_tag: "Campaign",
    group: "Information",
  },
  {
    title: "Upload Spots",
    api: "/upload-spots",

    userTypes: [
      "bkash-super-user",
      "territory_manager",
      "area_manager",
      "cluster_head",
    ],
    file_tag: "Spot Update",
    group: "Entity",
  },
  {
    title: "Upload Outlet Tagging",
    api: "/upload-outlet-tagging",

    userTypes: [
      "bkash-super-user",
      "territory_manager",
      "area_manager",
      "cluster_head",
    ],
    file_tag: "MDO Tagging",
    group: "Mapping",
  },

  {
    title: "Upload MDO Spots Mapping",
    api: "/spot-mapping-update",
    userTypes: [
      "bkash-super-user",
      "territory_manager",
      "area_manager",
      "cluster_head",
    ],
    file_tag: "MDO Spot Mapping Update",
    group: "Mapping",
  },
  {
    title: "Upload Distributor",
    api: "/upload-agencies",
    userTypes: ["bkash-super-user", "area_manager", "cluster_head"],
    file_tag: "Agency Update",
    group: "Entity",
  },

  {
    title: "Upload Merchant Bill Info",
    api: "/upload-bill-info",
    userTypes: ["bkash-super-user", "area_manager", "cluster_head"],
    file_tag: "Bill Info Update",
    group: "Information",
  },
  {
    title: "Upload route info",
    api: "/upload-route-info",
    userTypes: [
      "bkash-super-user",
      "territory_manager",
      "area_manager",
      "cluster_head",
    ],
    file_tag: "Route Creation",
    group: "Information",
  },
  {
    title: "Outlet route mapping",
    api: "/upload-route-outlet-mapping",
    userTypes: [
      "bkash-super-user",
      "territory_manager",
      "area_manager",
      "cluster_head",
    ],
    file_tag: "Route-Outlet Mapping",
    group: "Mapping",
  },
  {
    title: "Field force route mapping",
    api: "/upload-route-mmo-mapping",
    userTypes: [
      "bkash-super-user",
      "territory_manager",
      "area_manager",
      "cluster_head",
    ],
    file_tag: "Route-FieldForce Mapping",
    group: "Mapping",
  },
  {
    title: "Merchant KYC upload",
    api: "/upload-merchant-kyc-data",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Merchant-KYC Update",
    isEmailRequired: true,
    group: "Information",
  },
  {
    title: "Merchant Tag upload",
    api: "/upload-merchant-tags",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Merchant-tag Update",
    isEmailRequired: true,
    group: "Mapping",
    isDownlaodDisabled: true,
    uploadVariations: [
      {
        title: "Upload Life Cycle tag",
        api: "/upload-merchant-tags",
        tag: "life_cycle",
        file_tag: "Merchant-tag Update",
        customIndex: "L",
      },
      {
        title: "Upload Shopping Mall tag",
        api: "/upload-merchant-tags",
        tag: "shopping_mall",
        file_tag: "Merchant-tag Update",
        customIndex: "S",
      },
      {
        title: "Upload Geography tag ",
        api: "/upload-merchant-tags",
        tag: "geography",
        file_tag: "Merchant-tag Update",
        customIndex: "G",
      },
      {
        title: "Upload Segment tag",
        api: "/upload-merchant-tags",
        tag: "segment",
        file_tag: "Merchant-tag Update",
        customIndex: "S",
      },
      {
        title: "Upload Campaign tag",
        api: "/upload-merchant-tags",
        tag: "campaign",
        file_tag: "Merchant-tag Update",
        customIndex: "C",
      },
    ],
  },
  {
    title: "Agency Thana-District Mapping",
    api: "/upload-agencies-geography",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Agency Geography Update",
    group: "Mapping",
  },
  {
    title: "Outlet Lat Lng Mapping",
    api: "/upload-outlet-lat-lng",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "MDO Lat Lng Tagging",
    group: "Mapping",
  },
  {
    title: "Agency Lat Long Mapping",
    api: "/upload-agency-lat-lng",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Agency Location Lat Lng Tagging",
    group: "Mapping",
  },
  {
    title: "Categorization Validation Uploader",
    api: "/upload-merchant-categorization-validator",
    variants: [
      {
        id: "BUSINESS_PILLAR_SUB_PILLAR",
        name: "Business Pillars, Sub-pillars",
      },
      {
        id: "SUB_PILLAR_CATEGORY",
        name: "Sub pillar merchant category",
      },
      {
        id: "MERCHANT_CATEGORY_SUB_CATEGORY",
        name: "Merchant category, Merchant sub-category",
      },
      {
        id: "MERCHANT_IRRELATIONSHIP_FIELDS",
        name: "Merchant categorization fields",
      },
      { id: "BMCC_CODE_NAME", name: "BMCC CODE " },
      { id: "MCC_CODE_NAME", name: "MCC CODE " },
    ],
    userTypes: ["bkash-super-user", "cluster_head"],
    group: "Discontinued",
  },
  {
    title: "Upload Distributor Target",
    api: "/upload-agency-target",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Agency Target Update",
    group: "Targets",
  },
  {
    title: "Upload Route Target",
    api: "/upload-route-target",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Route Target Update",
    group: "Targets",
  },
  {
    title: "Upload Employee target",
    api: "/upload-field-force-target",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Field Force Target Update",
    group: "Targets",
  },
  {
    title: "Upload Acquisition Target Configuration",
    api: "/upload-acquisition-target-configuration",
    userTypes: ["bkash-super-user", "cluster_head"],
    file_tag: "Acquisition Target Configuration Update",
    group: "Targets",
  },

  {
    title: "Eligibility Uploader",
    api: "/upload-device-eligibility",
    userTypes: ["bkash-super-user"],
    file_tag: "Payment Speaker Eligibility",
    group: "Inventory",
  },

  {
    title: "Payment Scheme Uploader",
    api: "/upload-device-payment-scheme",
    userTypes: ["bkash-super-user"],
    file_tag: "Payment Speaker Payment Scheme",
    group: "Inventory",
  },

  {
    title: "Upload Lead Tagging",
    api: "/upload-online-lead-tagging",
    scope: "online",
    file_tag: "Online Lead Tagging",
  },
  {
    title: "Upload Lead Registration",
    api: "/upload-online-registration-status",
    scope: "online",
    file_tag: "Lead Registration",
  },
  {
    title: "Upload Online MAO Target",
    api: "/upload-online-mao-target",
    scope: "online",
    file_tag: "Online MAO Target",
  },
  {
    title: "Inventory Location Correction Uploader",
    api: "/bulk-location-correction",
    userTypes: ["bkash-super-user"],
    file_tag: "bulk-location-correction",
    group: "Payment Speaker",
    feedbackResponse: true,
  },
];

const uploadList = pushIndex(uploads);
export { uploadList };
